import { InclusionHeatMapCardProps } from '@diversioteam/diversio-ds'

import { getInclusionHeatmap } from '../sagas/network'
import { Queries } from 'api/queries.enum'

import { useQuery } from './useQuery'

export const useInclusionHeatmap = () => {
    const query = useQuery<InclusionHeatMapCardProps<'div'>['results'], Error>({
        queryKey: [Queries.getInclusionHeatmap],
        queryFn: getInclusionHeatmap,
    })

    return query
}
